<template>
  <div>
    <b-row>
      <b-col xl="3" lg="4" md="5">
        <FormCardProfileVue :loading="loading" />
      </b-col>
      <b-col xl="9" lg="8" md="7">
        <b-tabs>
          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Pessoal</span>
            </template>
            <FormPersonalInfoVue :loading="loading" />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_FINAN_CONSULTAR')">
            <template #title>
              <feather-icon icon="DollarSignIcon" />
              <span>Financeiro</span>
            </template>
            <FormFinacialVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ATEND_CONSULTAR')">
            <template #title>
              <feather-icon icon="PhoneIcon" />
              <span>Atendimento</span>
            </template>
            <FormAttendanceVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="LinkIcon" />
              <span>Vinculos</span>
            </template>
            <FormLinkVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_ADMIM_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileTextIcon" />
              <span>Documentos</span>
            </template>
            <FormDocumentationsVue />
          </b-tab>

          <b-tab disabled>
            <template #title>
              <feather-icon icon="CalendarIcon" />
              <span>Eventos</span>
            </template>
            <FormEventsVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_CORE_CONSULTAR')">
            <template #title>
              <feather-icon icon="FileIcon" />
              <span>Protocolos</span>
            </template>
            <FormProtocolVue />
          </b-tab>

          <b-tab v-if="verificarPermissao('ROLE_RELATORIO_CONSULTAR')">
            <template #title>
              <feather-icon icon="PrinterIcon" />
              <span>Relatorios</span>
            </template>
            <FormReportsVue />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { BRow, BCol, BTabs, BTab } from 'bootstrap-vue'

import mixinsGlobal from '@/mixins'
import FormPersonalInfoVue from '../dependents/forms/personal/FormDependents.vue'
import FormFinacialVue from '../dependents/forms/finance/FormFinancial.vue'
import FormAttendanceVue from '../dependents/forms/attendance/FormAttendance.vue'
import FormDocumentationsVue from '../dependents/forms/documentations/FormDocumentations.vue'
import FormEventsVue from '../dependents/forms/events/FormEvents.vue'
import FormReportsVue from '../dependents/forms/report/GridReport.vue'
import FormLinkVue from '../dependents/forms/link/FormLink.vue'
import FormProtocolVue from '../dependents/forms/protocol/FormProtocol.vue'
import FormCardProfileVue from '../dependents/forms/personal/FormCardProfileDependent.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    FormPersonalInfoVue,
    FormFinacialVue,
    FormAttendanceVue,
    FormDocumentationsVue,
    FormEventsVue,
    FormReportsVue,
    FormCardProfileVue,
    FormLinkVue,
    FormProtocolVue
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      loading: true
    }
  },
  async mounted() {
    this.loading = true
    try {
      const response = await this.$store.dispatch(
        'dependentAdministrativeModule/getDependentID',
        this.$route.params.id
      )
      const objectDepedent = response.data
      if (objectDepedent.foto) {
        objectDepedent.foto = `data:image/jpeg;base64,${objectDepedent.foto}`
      }
      await this.$store.dispatch(
        'dependentAdministrativeModule/prepareToEditFullDependent',
        objectDepedent
      )
      this.$store.dispatch(
        'dependentAdministrativeModule/setAssociante',
        objectDepedent.associado
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboGenero'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboEstadoCivil'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboProfissoes'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboNaturalidades'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboNacionalidades'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboTypesRegister'
      )
      await this.$store.dispatch(
        'associantesAdministrativeModule/loadComboTypesRegister'
      )
      await this.$store.dispatch('dependentAdministrativeModule/loadComboUfs')
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboPrevidenciaSocial'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboTipoEndereco'
      )
      await this.$store.dispatch(
        'dependentAdministrativeModule/loadComboSituacaoRegistro'
      )
      await this.$store.dispatch('combosModule/loadComboFaixaContribuicao')
      this.loading = false
    } catch {
      this.MensagemError('Error', 'Erro ao carregar dados da tela!')
      this.loading = false
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
